import React, { createContext, useState } from "react";
import _ from "lodash";
const initialState = {};

export const ToolbarContext = createContext({
  currentSelection: initialState,
  upadateSelection: (_data) => {},
  upadateAction: (_actionName) => {},
});

export const ToolbarContextProvider = ({ children }) => {
  const [currentSelection, setCurrentSelection] = useState(initialState);

  const upadateSelection = (data) => {
    const type = _.get(currentSelection, "type");
    const action = _.get(currentSelection, "action");
    const index = _.get(currentSelection, "index", "");
    const selected = _.get(currentSelection, "selected");
    const cselected = _.get(data, "selected");

    _.set(data, "selection", cselected);
    setCurrentSelection(data);
    console.log("Last", type, action, index, selected);    
  };

  const upadateAction = (actionObj) => {
    if (_.get(actionObj, "action") === _.get(currentSelection, "action")) {
      let cloneState = { ...currentSelection };
      _.set(cloneState, "isEditing", _.get(actionObj, "isEditing"));
      _.set(cloneState, "selection", false);
      setCurrentSelection(cloneState);
      console.log(currentSelection);
    }
  };

  return (
    <ToolbarContext.Provider
      value={{ currentSelection, upadateSelection, upadateAction }}
    >
      {children}
    </ToolbarContext.Provider>
  );
};
